<template>
  <index-default ref="IndexDefault" :src-background="require('../assets/background-index.jpg')" :src-logo="require('@/assets/logo-colorida.png')"
                 background-color-image="var(--primary-color)" :system-type="$store.state.baseStore.systemTypes.TENANT_SYSTEM" full-size-background
                 alt-logo="'Logo MKS Treinamentos'" :social-media-login="false">

    <template #custom-login>
      <validation-observer ref="formObserverLogin" v-slot="{ handleSubmit }">
        <v-form ref="form" @submit.prevent="handleSubmit(signInSubmit)">
          <validation-provider v-slot="{ errors }" name="login">
            <v-text-field v-model="form.login" ref="inputLogin" :rules="dynamicLogin.rule" :error-messages="errors[0]" dense label="Email / CPF / CNPJ"
                          v-masker="dynamicLogin.mask" outlined required type="email"></v-text-field>
          </validation-provider>

          <validation-provider v-slot="{ errors }" name="password">
            <v-text-field v-model="form.password" ref="password" :error-messages="errors[0]" :rules="formRules.requiredRule" dense label="Senha" outlined
                          required type="password"></v-text-field>
          </validation-provider>

          <v-layout class="mb-2" justify-space-between>
            <a class="text-decoration-underline" @click="$refs.IndexDefault.form.type = 'recovery'">Esqueceu sua senha?</a>
          </v-layout>
          <v-btn color="primary" :loading="buttonLoading" large type="submit" width="100%">
            Entrar
          </v-btn>
        </v-form>
      </validation-observer>
    </template>

    <template #custom-recovery>
      <div>
        <validation-observer ref="formObserverRecovery" v-slot="{ handleSubmit }">
          <v-form ref="form" @submit.prevent="handleSubmit(passwordRecoverySubmit)">
            <validation-provider v-slot="{ errors }" name="login">
              <v-text-field v-model="form.login" ref="inputLogin" :error-messages="errors" v-masker="dynamicLogin.mask" dense label="Email / CPF / CNPJ"
                            outlined required type="email" v-mask="dynamicLogin.mask"></v-text-field>
            </validation-provider>

            <v-btn class="mr-4" large type="button" @click.stop="$refs.IndexDefault.form.type = 'login'">
              Voltar
            </v-btn>
            <v-btn :disabled="buttonLoading" :loading="buttonLoading" color="primary" large type="submit">
              Enviar
            </v-btn>
          </v-form>
        </validation-observer>
      </div>
    </template>

  </index-default>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { mapState } from 'vuex';
import { catchFormError, handleSuccess, isNullOrEmpty } from 'erp-skeleton-library/utils';
import { VueMaskDirective } from 'v-mask';

export default {
  name: 'Index',
  directives: {
    masker: VueMaskDirective,
  },
  components: {
    IndexDefault: () => import('erp-skeleton-library/page-components/IndexDefault'),
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      buttonLoading: false,
      form: {
        login: null,
        password: null,
      },
      formPasswordChange: {
        password: null,
        passwordConfirm: null,
      },
    };
  },
  methods: {
    signInSubmit() {
      this.buttonLoading = true;
      this.$store.dispatch('baseStore/signIn', { ...this.form, type: this.$refs.systemType })
          .then((response) => {
            if (this.needToChangePassword(response.data)) {
              this.buttonLoading = false;
              this.$refs.IndexDefault.moveToChangePasswordDefault(response.data.token);
              return;
            }

            this.$router.push({
              name: 'dashboard',
            }).finally(() => this.buttonLoading = false);
          }).catch((error) => {
        this.buttonLoading = false;
        catchFormError(error, this.$refs.formObserverLogin);
      });
    },
    passwordRecoverySubmit() {
      this.buttonLoading = true;
      this.$store.dispatch('baseStore/passwordRecovery', { login: this.form.login })
          .then((response) => {
            handleSuccess(response, 'Foi enviado um email para a recuperação da senha.');
            this.$refs.IndexDefault.form.type = 'login';
            this.buttonLoading = false;
          }).catch(error => {
        catchFormError(error, this.$refs.formObserverRecovery);
        this.buttonLoading = false;
      });
    },
    needToChangePassword(data) {
      return !isNullOrEmpty(data.changePassword);
    },
  },
  computed: {
    loginIsNaN() {
      if (!!this.form.login) {
        return isNaN(parseInt(this.form.login.charAt(0)));
      } else {
        return true;
      }
    },
    dynamicLogin() {
      const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;

      if (!!this.form.login && !this.loginIsNaN && (!!this.form.login.length && (this.form.login.length < 15 && specialChars.test(this.form.login)) || (this.form.login.length < 12 && !specialChars.test(this.form.login)))) {
        return {
          mask: '###.###.###-##',
          rule: this.formRules.CPFRule,
        };
      } else if (!!this.form.login && !this.loginIsNaN) {
        return {
          mask: '##.###.###/####-##',
          rule: this.formRules.CNPJRule,
        };
      } else {
        return {
          rule: this.formRules.emailRequiredRule,
        };
      }
    },
    ...mapState('baseStore', [ 'formRules' ]),
  },
};
</script>

<style>
@media (max-width: 767px) {
  .v-application a {
    color: var(--primary-color);
  }
}
</style>
